/* eslint-disable import/prefer-default-export */

import React, { memo, useCallback } from 'react';
import { Button, Col, InputGroup, Input, InputGroupAddon } from 'reactstrap';
import CustomSelection from '../../../CustomSelection';
import { DROP_DOWN_TEXT, typeOptions } from '../../constants';
import filterIcon from '../../../../Res/Icon/filter.png';
import './index.styles.css';

export const NavFilterRow = memo(
  ({
    showNewNoteButton,
    selectedOption,
    filterDropDownOptions,
    handleFilterOptionsDropDownChange,
    onSavePress,
    handleChange,
    // onKeyPress,
    handleModal,
  }) => {
    const getInputField = useCallback(
      (mode, type = 'text') => (
        <>
          {mode === 'email' && (
            <>
              <Input
                type={type}
                placeholder="Filter"
                name="email"
                // value={}
                onChange={handleChange}
                // onKeyUp={onKeyPress}
                style={{ margin: '0 0 1em 5px' }}
              />
            </>
          )}
          {mode === 'date' && (
            <>
              <div className="custom-date-container">
                <h1>From:</h1>
                <Input
                  type="date"
                  name="from"
                  onChange={handleChange}
                  // onKeyDown={onKeyPress}
                  // value={this.state.FromDate}
                  style={{ margin: '0 0 1em 5px' }}
                />
                <h1>To:</h1>
                <Input
                  type="date"
                  name="to"
                  onChange={handleChange}
                  // onKeyDown={onKeyPress}
                  // value={this.state.toDate}
                  style={{ margin: '0 0 1em 5px' }}
                />
              </div>
            </>
          )}
          {mode === 'type' && (
            <>
              <CustomSelection name="type" onChange={handleChange} optionsList={typeOptions} />
            </>
          )}
        </>
      ),
      [],
    );

    return (
      <div className="nav-filter-row">
        <div className="nav-filter-row-child top-spacing">
          {showNewNoteButton && (
            <Button color="primary" onClick={handleModal} id="create_note">
              New Note
            </Button>
          )}
        </div>
        <div className="nav-filter-row-child nav-filter-row-child__right">
          <Col md={6} lg={4} className="push-right">
            <InputGroup>
              <InputGroupAddon addonType="prepend" className="filter-icon-div">
                <img src={filterIcon} className="filter-icon" alt="filter" />
              </InputGroupAddon>
              <CustomSelection
                name="filter"
                onChange={handleFilterOptionsDropDownChange}
                optionsList={filterDropDownOptions}
                value={selectedOption}
              />
            </InputGroup>
          </Col>
          <Col
            md={selectedOption.includes(DROP_DOWN_TEXT.DATE_RANGE) ? 8 : 6}
            lg={selectedOption.includes(DROP_DOWN_TEXT.DATE_RANGE) ? 8 : 4}
          >
            {(() => {
              switch (selectedOption) {
                case DROP_DOWN_TEXT.EMAIL:
                  return getInputField('email');
                case DROP_DOWN_TEXT.TYPE:
                  return getInputField('type');
                case DROP_DOWN_TEXT.DATE_RANGE:
                  return getInputField('date');
                default:
                  return null;
              }
            })()}
          </Col>
          <Col md={2} lg={2}>
            <Button
              color="primary"
              className="box-search-btn"
              onClick={() => onSavePress(selectedOption)}
            >
              Search
            </Button>
          </Col>
        </div>
      </div>
    );
  },
);
